module.exports = __webpack_public_path__ + "static/media/wedding3.a00c12a8.jpg";